import { apiClient } from '../../config/axios-client'
import type {
  AcceptedPlaygroundVideoGeneration,
  EligibleVideoSourceKind,
  PlaygroundVideoGalleryItem,
  PlaygroundVideoGeneration,
  PlaygroundVideoRequest,
  PlaygroundVideoSourcePage,
  VideoProvider,
  VideoValidationResponse,
} from '../../shared/models/PlaygroundVideo'

const basePath = (workspaceId: string) => `workspaces/${workspaceId}/playgrounds/video`

export const playgroundVideosApi = {
  providers: () => apiClient.get<VideoProvider[]>('videoproviders'),
  validate: (workspaceId: string, request: PlaygroundVideoRequest) =>
    apiClient.post<VideoValidationResponse>(`${basePath(workspaceId)}/validate`, request),
  generate: (workspaceId: string, request: PlaygroundVideoRequest) =>
    apiClient.post<AcceptedPlaygroundVideoGeneration>(
      `${basePath(workspaceId)}/generations`,
      request,
    ),
  active: (workspaceId: string) =>
    apiClient.get<PlaygroundVideoGeneration[]>(`${basePath(workspaceId)}/generations`),
  status: (workspaceId: string, activityId: string) =>
    apiClient.get<PlaygroundVideoGeneration>(`${basePath(workspaceId)}/generations/${activityId}`),
  videos: (workspaceId: string) =>
    apiClient.get<PlaygroundVideoGalleryItem[]>(`${basePath(workspaceId)}/videos`),
  sources: (
    workspaceId: string,
    kind: EligibleVideoSourceKind,
    provider?: string,
    limit = 20,
    continuationToken?: string,
  ) =>
    apiClient.get<PlaygroundVideoSourcePage>(`${basePath(workspaceId)}/sources`, {
      params: { kind, provider, limit, continuationToken },
    }),
}
